<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator" *ngIf="product.id">Editar Producto</h3>
            <h3 class="m-subheader__title m-subheader__title--separator" *ngIf="!product.id">Nuevo Producto</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/products'" class="m-nav__link">
                        <span class="m-nav__link-text">Productos</span>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a *ngIf="product.id == null" [routerLink]="'/products/create'" class="m-nav__link">
                        <span class="m-nav__link-text">Nuevo Producto</span>
                    </a>
                    <a *ngIf="product.id != null" [routerLink]="['/products/edit', product.id]" class="m-nav__link">
                        <span class="m-nav__link-text">Editar Producto</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 *ngIf="product.id == null" class="m-portlet__head-text">
                                Nuevo Producto
                            </h3>
                            <h3 *ngIf="product.id != null" class="m-portlet__head-text">
                                Editar Producto - {{product.name}}
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <a [routerLink]="'/products'"
                                   class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle">
                                    <i class="flaticon-reply"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <form class="m-form m-form--label-align-right">
                    <div class="m-portlet__body">
                        <div class="m-form__section m-form__section--first">
                            <div class="form-group m-form__group row">
                                <div class="col-10 ml-auto">
                                    <h3 class="m-form__section">Información del Producto</h3>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Nombre:</label>
                                <div class="col-lg-9">
                                    <input [(ngModel)]="product.name" name="name" class="form-control m-input"
                                           placeholder="Nombre"
                                           [ngClass]="{ 'is-invalid': submitted && !product.name }">
                                    <div *ngIf="submitted && !product.name" class="invalid-feedback">
                                        <div>Nombre obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Comercio:</label>
                                <div *ngIf="!this.id" class="col-lg-9">
                                    <ng-select2
                                            name="category_id"
                                            [(ngModel)]="product.merchant_id"
                                            [data]="merchants"
                                            [options]="optionsSelect2"
                                            placeholder="Selecciona un Comercio">
                                    </ng-select2>
                                    <div *ngIf="submitted && !product.merchant_id" class="invalid-feedback">
                                        <div>Comercio obligatorio</div>
                                    </div>
                                </div>
                                <div *ngIf="this.id" class="col-lg-9">
                                    <p style="padding-top: .8rem">{{product.merchant?.ruc}} - {{product.merchant?.name}}</p>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Categoría:</label>
                                <div class="col-lg-9">
                                    <ng-select2
                                            name="category_id"
                                            [(ngModel)]="product.category_id"
                                            [data]="categories"
                                            [options]="optionsSelect2"
                                            (valueChanged)="onSelectCategory($event)"
                                            placeholder="Selecciona una Categoría">
                                    </ng-select2>
                                    <div *ngIf="submitted && !product.category_id" class="invalid-feedback">
                                        <div>Categoría obligatoria</div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="brands.length > 0" class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Marcas:</label>
                                <div class="col-lg-9">
                                    <ng-select2
                                        name="brand_id"
                                        [(ngModel)]="product.brand_id"
                                        [data]="brands"
                                        [options]="optionsSelect2"
                                        (valueChanged)="onSelectBrand($event)"
                                        placeholder="Selecciona una Marca">
                                    </ng-select2>
                                </div>
                            </div>
                            <div *ngIf="type_products.length > 0" class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Tipo Producto:</label>
                                <div class="col-lg-9">
                                    <ng-select2
                                        name="type_product_id"
                                        [(ngModel)]="product.type_product_id"
                                        [data]="type_products"
                                        [options]="optionsSelect2"
                                        (valueChanged)="onSelectTypeProduct($event)"
                                        placeholder="Selecciona un Tipo Producto">
                                    </ng-select2>
                                </div>
                            </div>
                            <div *ngIf="sub_type_products.length > 0" class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Subtipo Producto:</label>
                                <div class="col-lg-9">
                                    <ng-select2
                                        name="sub_type_product_id"
                                        [(ngModel)]="product.sub_type_product_id"
                                        [data]="sub_type_products"
                                        [options]="optionsSelect2"
                                        placeholder="Selecciona un Subtipo Producto">
                                    </ng-select2>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Descripción:</label>
                                <div class="col-lg-9">
                                    <ckeditor [(ngModel)]="product.description" [editor]="Editor"
                                              name="description"
                                              [ngClass]="{ 'is-invalid': submitted && !product.description }"
                                              [config]="configEditor"></ckeditor>
                                    <div *ngIf="submitted && !product.description" class="invalid-feedback">
                                        <div>Descripción obligatorio</div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Más características:</label>
                                <div class="col-lg-9">
                                    <input type="file" class="form-control m-input" id="customFileSingleForm"
                                           (change)="onSelectFileArchive($event)">
                                    <label class="custom-file-label" for="customFileSingleForm">
                                        {{FileNameLoaded}}
                                    </label>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Producto:</label>
                                <div class="col-lg-9">
                                    <select [(ngModel)]="product.product_status"
                                            name="product_status" class="form-control m-input">
                                        <option value="null">Seleccione una opcion</option>
                                        <option value="1">Seminuevo</option>
                                        <option value="2">Nuevo</option>
                                    </select>
                                    <div *ngIf="submitted && !product.product_status" class="invalid-feedback">
                                        <div>Campo obligatorio</div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Estado:</label>
                                <div class="col-lg-9">
                                    <select [(ngModel)]="product.status"
                                            name="status" class="form-control m-input">
                                        <option value="1">Activo</option>
                                        <option value="0">Inactivo</option>
                                    </select>
                                </div>
                            </div>
                            <div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
                            <div class="form-group m-form__group row">
                                <div class="col-10 ml-auto">
                                    <h3 class="m-form__section">Variantes</h3>
                                </div>
                            </div>
                            <ng-container *ngIf="!product.id">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label"></label>
                                    <div class="col-lg-9">
                                        <table class="table table-bordered table-condensed">
                                            <thead>
                                            <tr>
                                                <th>Nombre de Opción</th>
                                                <th>Valores de Opción</th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr *ngFor="let variant of product.variants; let i = index">
                                                <td>
                                                    <input [(ngModel)]="variant.name" class="form-control m-input"
                                                           placeholder="Nombre" [ngModelOptions]="{standalone: true}">
                                                </td>
                                                <td>
                                                    <tag-input [(ngModel)]="variant.details"
                                                               [ngModelOptions]="{standalone: true}"
                                                               [placeholder]="'Agregar Variantes'"
                                                               [modelAsStrings]="true"
                                                               [secondaryPlaceholder]="'Agregar Variantes'"
                                                               (onAdd)="calculateCombinations()"
                                                               (onRemove)="calculateCombinations()"></tag-input>
                                                </td>
                                                <td>
                                                    <button type="button" (click)="deleteVariant(i)"
                                                            class="btn btn-danger">
                                                        <i class="la la-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <button *ngIf="product.variants.length < 3" type="button" (click)="addVariant()"
                                                class="btn btn-primary">
                                            Agregar Variante
                                        </button>
                                        <div class="div-table-combinations">
                                            <table class="table table-bordered table-condensed table-combinations">
                                                <thead>
                                                <tr>
                                                    <th>Variante</th>
                                                    <th>Precio</th>
                                                    <th>Precio Antiguo</th>
                                                    <th>Stock</th>
                                                    <th>Foto</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let combination of product.combinations">
                                                    <td>{{ combination.name_variant_combination }}</td>
                                                    <td>
                                                        <input type="text" [(ngModel)]="combination.price"
                                                               appOnlyNumber
                                                               [ngModelOptions]="{standalone: true}"
                                                               class="form-control">
                                                    </td>
                                                    <td>
                                                        <input type="text" [(ngModel)]="combination.old_price"
                                                               appOnlyNumber
                                                               [ngModelOptions]="{standalone: true}"
                                                               class="form-control">
                                                    </td>
                                                    <td>
                                                        <input type="text" [(ngModel)]="combination.stock"
                                                               appOnlyIntNumber
                                                               [ngModelOptions]="{standalone: true}"
                                                               class="form-control">
                                                    </td>
                                                    <td>
                                                        <div class="custom-file">
                                                            <input type="file" class="custom-file-input"
                                                                   (change)="onSelectFile($event, combination)"
                                                                   accept="image/x-png,image/jpg,image/jpeg">
                                                            <label class="custom-file-label selected">
                                                                {{(combination.photo?.length > 22) ? (combination.photo | slice:0:22) + '..' : 'Elegir Foto'}}
                                                            </label>
                                                        </div>
                                                        <img *ngIf="combination.selected" [src]="combination.photo_url"
                                                             [alt]="product.name" class="img-fluid img-combination"/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="product.id">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-2 col-form-label"></label>
                                    <div class="col-lg-9">
                                        <table class="table table-bordered table-condensed table-combinations">
                                            <thead>
                                            <tr>
                                                <th>Variante</th>
                                                <th>Precio</th>
                                                <th>Precio Antiguo</th>
                                                <th>Stock</th>
                                                <th>Foto</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr *ngFor="let item of product.variants_combinations_stored">
                                                <td>{{item.text}}</td>
                                                <td>
                                                    <input type="text" [(ngModel)]="item.price"
                                                           appOnlyNumber
                                                           [ngModelOptions]="{standalone: true}"
                                                           class="form-control">
                                                </td>
                                                <td>
                                                    <input type="text" [(ngModel)]="item.old_price"
                                                           appOnlyNumber
                                                           [ngModelOptions]="{standalone: true}"
                                                           class="form-control">
                                                </td>
                                                <td>{{item.stock}}</td>
                                                <td>
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input"
                                                               (change)="onSelectFile($event, item)"
                                                               accept="image/x-png,image/jpg,image/jpeg">
                                                        <label class="custom-file-label selected">
                                                            {{(item.photo?.length > 22) ? (item.photo | slice:0:22) + '..' : 'Elegir Foto'}}
                                                        </label>
                                                    </div>
                                                    <img *ngIf="item.photo" [src]="item.photo_url"
                                                         [alt]="product.name" class="img-fluid img-combination"/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x"></div>
                            <div class="form-group m-form__group row">
                                <div class="col-10 ml-auto">
                                    <h3 class="m-form__section">SEO</h3>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Título:</label>
                                <div class="col-lg-9">
                                    <input [(ngModel)]="product.title_seo"
                                           [ngClass]="{ 'is-invalid': submitted && !product.title_seo }"
                                           name="title_seo" class="form-control m-input"
                                           placeholder="Título">
                                    <div *ngIf="submitted && !product.title_seo" class="invalid-feedback">
                                        <div>Nombre obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Descripción:</label>
                                <div class="col-lg-9">
                                    <input [(ngModel)]="product.description_seo"
                                           [ngClass]="{ 'is-invalid': submitted && !product.description_seo }"
                                           name="description_seo"
                                           class="form-control m-input"
                                           placeholder="Descripción">
                                    <div *ngIf="submitted && !product.description_seo" class="invalid-feedback">
                                        <div>Nombre obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">keywords:</label>
                                <div class="col-lg-9">
                                    <input [(ngModel)]="product.keywords"
                                           [ngClass]="{ 'is-invalid': submitted && !product.keywords }"
                                           name="keywords" class="form-control m-input"
                                           placeholder="keywords">
                                    <div *ngIf="submitted && !product.keywords" class="invalid-feedback">
                                        <div>Nombre obligatorio</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot m-portlet__foot--fit">
                        <div class="m-form__actions">
                            <div class="row">
                                <div class="col-2">
                                </div>
                                <div class="col-7">
                                    <button type="submit" [disabled]="loading"
                                            (click)="sendForm()"
                                            class="btn btn-accent m-btn m-btn--air m-btn--custom"
                                            [ngClass]="{'m-loader m-loader--light m-loader--right': loading}">
                                        Guardar Cambios
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
